<div class="bg-white shadow rounded-lg p-6 mb-8 text-center mt-4">
  <h1 class="text-2xl font-bold mb-2">Liste des formations</h1>

  <p-table [value]="sortedFormations()" [paginator]="true" [rows]="10" class="mt-4">
    <ng-template pTemplate="header">
      <tr>
        <th>Titre</th>
        <th>Prix (€)</th>
        <th>Statut</th>
        <th>Date création</th>
        <th>Actions</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-formation>
      <tr>
        <td>{{ formation.title }}</td>
        <td>{{ formation.price_eur }} €</td>
        <td>
          <span
            [class.text-green-600]="formation.is_active"
            [class.text-red-600]="!formation.is_active">
            {{ formation.is_active ? 'Active' : 'Inactive' }}
          </span>
        </td>
        <td>{{ formation.created_at | date }}</td>
        <td>
          <button
            pButton
            icon="pi pi-pencil"
            class="p-button-rounded p-button-text"
            (click)="editFormation(formation)">
          </button>

          <button
            pButton
            icon="pi pi-trash"
            class="p-button-rounded p-button-text"
            (click)="deleteFormation(formation, $event)">
          </button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-confirmdialog />
<p-toast />
